export const invertedMessages = {
  'Resync is in progress. Please retry after some time.': 'Certs.Resync.Info',
  'A certification discrepancy has been detected. Kindly connect with your administrator to review and address this issue.':
    'Certs.admin.disprepancy.message',
};
